/**
 * True when `pathname` points at `path` or one of its child routes.
 *
 * `pathname` (from the router) is slash-prefixed (`/organisations`) while menu
 * paths are bare segments (`organisations`), so both are normalized first.
 */
const isActivePath = (pathname: string, path: string) => {
	const current = pathname.replace(/^\/+/, '');
	const target = path.replace(/^\/+/, '');
	if (target === '') {
		return current === '';
	}
	return current === target || current.startsWith(`${target}/`);
};

export default isActivePath;
